const ENDPOINT = process.env.REACT_APP_API_URL

function getXsrfToken() {
  const match = document.cookie.match(/(?:^|; )XSRF-TOKEN=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

 export default function login ({ username, password }) {
  return fetch(`${ENDPOINT}/auth/login`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-XSRF-TOKEN": getXsrfToken()
    },
    body: JSON.stringify({ 'email':username, password, 'device_name':'computer'})
  }).then(res => {
    if (!res.ok) throw new Error('Response is NOT ok')
     return res.json() }).then(({token, id_user, puntos, concentrado, rol, nombre, distribuidor, foto}) => {
    return {token, id_user, puntos, concentrado, rol, nombre, distribuidor, foto}
  })
} 